import { useDispatch, useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as IssuesV2Store from '../../../redux/issuesV2';
import Checkbox from '../../generic/Forms/Checkbox';

/**
 * IssuesSelectAllCheckbox is the checkbox at the top of the UI
 * which is responsible for "bulk selecting" the issues.
 */
const IssuesSelectAllCheckbox: VoidFunctionComponent = () => {
  const dispatch = useDispatch();
  const checkboxState = useSelector(IssuesV2Store.selectors.getBulkCheckboxState);
  const isComparisonModeOn = useSelector(IssuesV2Store.selectors.getComparisonMode);

  if (isComparisonModeOn) {
    return null;
  }

  return (
    <div className="issues-table__header__select-all-checkbox">
      <Checkbox
        isIndeterminate={checkboxState === 'indeterminate'}
        isChecked={checkboxState === 'checked'}
        onChange={() => dispatch(IssuesV2Store.actions.toggleSelectAllOnPage())}
        testId="issues-inbox-checkbox-select-all"
        isRippleDisabled
      />
    </div>
  );
};

export default IssuesSelectAllCheckbox;
